import React from 'react';

import {Skeleton, Stack, Paper, Typography} from 'views/components';
import {AccessTime as AccessTimeIcon} from 'views/icons';
import {Translate} from 'views/module';

const TimeTileSkeleton = () => {
  return (
    <Paper sx={{p: 2, mb: 2, borderRadius: 4, height: 136}}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{mb: 2}}>
        <AccessTimeIcon sx={{width: 24, height: 24, color: '#b0b0b0'}}/>
        <Typography variant="h6">
          <Translate expression='schedule.eventDetail.TimeSection.Title' />
        </Typography>
      </Stack>
      <Stack spacing={1}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Skeleton variant="circular" width={20} height={20} />
          <Skeleton variant="text" width={200} height={16} />
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Skeleton variant="circular" width={20} height={20} />
          <Skeleton variant="text" width={160} height={16} />
          <Skeleton variant="text" width={80} height={16} />
        </Stack>
      </Stack>
    </Paper>
  );
};

export default TimeTileSkeleton;
